/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Kind_LabelInputs */



/**
* | output |
* | --- |
* | "Kind of meeting" |
*
* @param {Settings_Template_Kind_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_kind_label = /** @type {((inputs?: Settings_Template_Kind_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Kind_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Soort gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de réunion")
	return /** @type {LocalizedString} */ ("Kind of meeting")
});